import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 代码加载期间保留记录页五项筛选、操作按钮和九列结构 */
export function AdvancedAssetGroupRecordsSkeleton() {
  return (
    <ListPageSkeleton
      columnCount={9}
      showPagination={false}
      contentClassName="gap-2 p-0 pb-4"
      filterArea={
        <div className="flex flex-wrap items-center gap-2 px-4 pt-4">
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton key={index} className="h-9 w-45" />
          ))}
          <Skeleton className="h-9 w-65" />
          <div className="ml-auto flex gap-2">
            <Skeleton className="h-9 w-20" />
            <Skeleton className="h-9 w-20" />
            <Skeleton className="h-9 w-24" />
          </div>
        </div>
      }
    />
  );
}
